var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconInviteAccepted = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "#00BC6F",
  rx: 9
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12.8 4.757a.683.683 0 0 1 .933-.128.63.63 0 0 1 .18.832l-.046.068-6 7.714a.683.683 0 0 1-.997.077l-.057-.061-2.667-3.215a.627.627 0 0 1 .104-.903.685.685 0 0 1 .881.04l.056.06 2.129 2.567z"
}))));
export default SvgIconInviteAccepted;